import { NgModule } from '@angular/core';
import { SharedModule } from '~app/app/~shared/modules/shared.module';
import { SubscriberAdvertiserLayoutComponent } from './layouts/subscriber-advertiser-layout/subscriber-advertiser-layout.component';
import { SubscriberAdvertiserCardComponent } from './components/subscriber-advertiser-card/subscriber-advertiser-card.component';
import { SubscriberAdvertiserDatatableComponent } from './components/subscriber-advertiser-datatable/subscriber-advertiser-datatable.component';

const DECLARATIONS = [
  SubscriberAdvertiserLayoutComponent,
  SubscriberAdvertiserCardComponent,
  SubscriberAdvertiserDatatableComponent
];

const MODULES = [SharedModule];

// const IMPORT_ONLY_MODULES = [NgxsModule.forFeature([])];

@NgModule({
  declarations: DECLARATIONS,
  // imports: [...MODULES, ...IMPORT_ONLY_MODULES],
  imports: [...MODULES],
  exports: [...MODULES, ...DECLARATIONS],
  providers: []
})
export class SubscriberAdvertiserModule {}
